import React, { useState } from 'react';
import { useNavigate  } from 'react-router-dom';
import "./langStyle.css"

const inputStyle ={
    width: '80%',
    fontSize: '12px',
    border: 'none',
    boxShadow: '0 1px 2px 1px rgb(70 70 70 / 30%)',
    borderRadius: '5px',
    padding: '3%',
    margin: '2%',
    outline: 'none',
}

const serachIcon = {
    width: '20px',
    padding: '1%',
    fontSize: '20px',
}
const languageIcon = {
    width: '20px',
    padding: '1%',
    fontSize: '20px'
}


function HeaderConfig(props) {
    const navigate  = useNavigate ();
    const [ShowSearchInput, setShowSearchInput] = useState(false);

    const LoginRegHandler = () => {
        const offCanvasConfig = document.querySelector('.off-canvas-cog');
        offCanvasConfig.classList.add('active');
        document.querySelector('body').classList.add('fix');
    }

    const MobileMenuHandler = () => {
        const offCanvasMenu = document.querySelector('.off-canvas-menu');
        offCanvasMenu.classList.add('active');
    }
    
    

    return (
        <div className="header-action mt-lg-3 text-right">
        {/* //     <a href="tel:09120000000" className="tel-no">09120000000</a>
        //     <button onClick={LoginRegHandler} className="btn-cog"><i className="fa fa-cog"/></button> */}
        <div class="search-container" style={{display:"flex", justifyContent:"flex-end", gap:"10%"}}>
            <div style={{width:'auto', display:"flex", justifyContent:"space-between", gap:'10%', minWidth:"50px"}}>
                {/* <form> */}
                    {
                        ShowSearchInput?                        
                        <input type="text" placeholder="جستجو.." name="search" style={inputStyle} 
                        onKeyPress={(e) => {
                            if (e.key === "Enter") {
                                navigate(`/searchedItemPage?search=${e.target.value}`)
                            }
                        }}/>
                        :
                        null
                    }
                    <button style={serachIcon} onClick={()=> setShowSearchInput(!ShowSearchInput)}><i className="fa fa-search"/></button>
                {/* </form> */}
                <div class="dropdown-lang">
                    <button  style={languageIcon}><i className='fa fa-globe'/></button>
                    <div class="dropdown-content-lang">
                        <a href={`https://en.parsswitch.com`}>en</a>
                        <a href={`https://www.parsswitch.com`}>fa</a>
                    </div>
                </div>
            </div>
            <button onClick={MobileMenuHandler} className="btn-menu d-lg-none">
                <i style={{color:'#000'}} className="fa fa-bars"/>

            </button>
        </div>
        </div>
    );
}

export default HeaderConfig;
